import { Users, Clock, BarChart, Star, GraduationCap } from 'lucide-react';

const COURSE = {
  id: '1',
  title: 'Seller Account Setup Course',
  instructor: 'Manikandan',
  rating: 4.9,
  students: 8450,
  duration: '12h 30m',
  level: 'Beginner',
  price: 'Free',
}

const courseStats = [
  {
    icon: Users,
    label: 'Learners',
    value: COURSE.students.toLocaleString(),
    color: 'orange'
  },
  {
    icon: Clock,
    label: 'Duration',
    value: COURSE.duration,
    color: 'amber'
  },
  {
    icon: BarChart,
    label: 'Level',
    value: COURSE.level,
    color: 'emerald'
  },
  {
    icon: GraduationCap,
    label: 'Type',
    value: 'Self-Paced',
    color: 'blue'
  }
]

export default function CourseBar() {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-4">
      {courseStats.map((stat, index) => (
        <div key={index} className="flex flex-col sm:flex-row items-center sm:items-start gap-4 text-center sm:text-left group">
          <div className={`w-14 h-14 rounded-2xl bg-${stat.color}-50 flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300 border border-${stat.color}-100`}>
            <stat.icon 
              className={`w-6 h-6 text-${stat.color}-600`} 
            />
          </div>
          <div className="flex flex-col gap-1">
            <p className="text-[10px] text-slate-400 uppercase font-black tracking-[0.1em]">
              {stat.label}
            </p>
            <p className="font-black text-slate-900 text-base md:text-lg leading-tight">
              {stat.value}
            </p>
          </div>
        </div>
      ))}
    </div>
  )
}